import type { ISupportInfo } from "../../types";

export const helpInfo: ISupportInfo[] = [
  {
    email: "support@draivn.com",
    phone: "+1 430-266-3848",
  },
];
